<template>
  <div v-if="data" class="md-layout">
    <div
      class="md-layout-item md-size-45 md-medium-size-60 md-small-size-60 md-xsmall-size-100"
    >
      <md-card class="rounded-xl">
        <md-card-header class=" md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title text-lg">{{ $t("smi_sri.general") }}</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <div class="flex">
            <!-- avatar -->
            <div
              class="md-layout-item md-size-25 md-medium-size-30 items-center"
            >
              <img
                :src="data.avatarUrl || '/img/avt_placeholder.jpg'"
                alt="Avatar student"
                class="object-cover rounded-full w-16 h-16 md:w-24 md:h-24"
              />
            </div>
            <!-- avatar -->
            <div class="px-0 items-center pl-5 pt-4">
              <p>
                <label class="font-medium text-xl"
                  >{{ $t("common.full_name") }}:
                </label>
                <span class=" text-xl font-medium">
                  {{ data.fullName }}
                </span>
              </p>
              <p>
                <label>{{ $t("common.student_code") }} : </label>
                <span>{{ data.studentCode }} </span>
              </p>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <div class="md-layout-item md-size-100">
      <slot></slot>
    </div>
  </div>
  <div class="md-layout" v-else>
    <div class="md-layout-item md-empty-page">
      <student-image class="student-image w-full"></student-image>
      <div>
        <h2 style="font-weight: 700; font-size: 26px">
          {{ $t("smi_sri.get_report") }}
        </h2>
        <p>
          {{ $t("smi_sri.please_select_the_student_to_view_report") }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import StudentImage from "@/components/Base/Illustration/Student";

export default {
  components: { StudentImage },
  props: ["data"]
};
</script>
<style lang="scss">
.md-table-head-label {
  width: 100%;
}
.md-empty-page {
  text-align: center;
  width: 100%;
  .student-image {
    border: none;
    display: inline-block;
  }
}
</style>
